import { useRender } from '@base-ui/react/use-render';
import { iconButtonStyles } from './icon-button-styles';
/**
 * Icon-only navigation. Renders an `<a>` (link semantics, no disabled state). `aria-label` is
 * required since there is no visible text to derive an accessible name from. For actions, use
 * `IconButton`.
 */
export const IconButtonLink = ({ icon, variant = 'darkGrey', shape = 'square', className, render, ...props }) => useRender({
    render,
    defaultTagName: 'a',
    props: {
        className: iconButtonStyles({ variant, shape, className }),
        children: icon,
        ...props,
    },
});
